import { Add, Search } from '@mui/icons-material';
import { Box, Button, InputAdornment, MenuItem, TextField, Typography } from '@mui/material';
import { FC, useMemo, useState } from 'react';

import { useNavigateDialogForm } from '../../../components/formikDialogForm/dialogForm.hook';
import { VisibleIfAdmin } from '../../auth/components/VisibleIfAdmin';
import { useFindAllInteressentQuery } from '../../kunde/api/kundeApi';
import { interessentenStatusOptions, InteressentenStatus } from '../../kunde/api/types';

import { filterInteressentenBySearch } from './interessentFilter';
import { InteressentFunnel } from './InteressentFunnel';
import { InteressentTable } from './InteressentTable';

export const InteressentListScreen: FC = () => {
  const navigateDialog = useNavigateDialogForm('interessent', 'create');
  const { data: interessenten = [], isFetching } = useFindAllInteressentQuery();
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState<InteressentenStatus | ''>('');

  const durchsuchteInteressenten = useMemo(
    () => filterInteressentenBySearch(interessenten, search),
    [interessenten, search]
  );

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Interessenten
      </Typography>
      {/*<VisibleIfAdmin>*/}
      <Button
        variant="contained"
        color="secondary"
        startIcon={<Add />}
        onClick={() => navigateDialog()}
        sx={{ mb: 3 }}
      >
        Neuer Interessent
      </Button>
      {/*</VisibleIfAdmin>*/}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          mb: 2,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <TextField
          label="Suchen"
          value={search}
          onChange={event => setSearch(event.target.value)}
          sx={{ minWidth: 280, flexGrow: 1 }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            },
          }}
        />
        <TextField
          select
          label="Status"
          value={status}
          onChange={event => setStatus(event.target.value as InteressentenStatus | '')}
          sx={{ minWidth: 230 }}
        >
          <MenuItem value="">Alle Status</MenuItem>
          {interessentenStatusOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <InteressentFunnel
        interessenten={durchsuchteInteressenten}
        selectedStatus={status}
        onStatusChange={setStatus}
      />
      <InteressentTable
        interessenten={durchsuchteInteressenten}
        isFetching={isFetching}
        status={status}
      />
    </Box>
  );
};
